import * as React from 'react';
import Map from 'react-map-gl';
// import { useContext } from 'react';
import '../App.css';
import Header from "./Header";
import Visible from "./Visible"
import { useMutation, useQuery, useSubscription, useLazyQuery } from '@apollo/client';
import Onboard from './Onboard';
import Demo from './Demo';
import Post from './Post';
import SelectedPosts from "./SelectedPosts";
// import SinglePost from "./SinglePost";
import SlidingPane from "react-sliding-pane";
import Login from './Login';
import Register from './Register';
import Profile from './Profile';
import postToGeoJSON from '../utils/postToGeoJSON';
import PostMap from './PostMap';
import Footer from './Footer';
// Queries and Mutations
import { GET_ALL_POSTS, GET_ME, GET_ONE_POST, GET_POSTS_IN_BOUNDS } from '../utils/queries';
import { POST_CREATED, POST_DELETED, POST_UPDATED } from '../utils/subscriptions';
import { ToastContainer, toast } from 'react-toastify';
import { useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Auth from '../utils/auth';
import getRandomPrompt from '../utils/getRandomPrompt';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { useLocation, useNavigate } from 'react-router-dom';
import { buildFilterQueryString, parseFilterQueryString } from '../utils/filterQueryParams';
import { buildGeoJSONSpatialIndex, pointInGeoJSONSpatialIndex } from '../utils/geoJSONQuadTree';

import 'react-toastify/dist/ReactToastify.css';

import "react-sliding-pane/dist/react-sliding-pane.css";
import { createTheme, ThemeProvider } from '@mui/material/styles';
const initialUser = Auth.getUserData().data?._id || null

const normalizeComparablePost = (post) => ({
  body: post?.body ?? '',
  iconColor: post?.iconColor ?? '',
  latitude: Number.isFinite(Number(post?.latitude)) ? Number(post.latitude) : null,
  longitude: Number.isFinite(Number(post?.longitude)) ? Number(post.longitude) : null,
  nearby: Boolean(post?.nearby),
  civicInfo: post?.civicInfo ?? null,
  issues: post?.issues ?? null,
  solutions: post?.solutions ?? null,
});

const isPostEquivalent = (a, b) => {
  if (!a || !b) return false;
  try {
    return JSON.stringify(normalizeComparablePost(a)) === JSON.stringify(normalizeComparablePost(b));
  } catch (error) {
    return false;
  }
};

const Main = () => {
const postReducer = (state, action) => {
  switch (action.type) {
    case 'ADD_INITIAL_POSTS':
      return action.post;
    case 'ADD_POST':
      // console.log("State:", state);
      return [...state, action.post];
    case 'DELETE_POST':
      // console.log("State:", state);
      return state.filter((post) => post._id !== action.post);
    case 'UPDATE_POST':
      return state.map((post) => (post._id === action.post._id ? action.post : post));
    case 'RESET_POSTS':
      return action.posts; // assuming that the original posts are passed as action.posts
    case 'FILTER_POSTS':
      return action.post;
    default:
      return state;
  }
}
  // Map states.
  // Paired in [ LONGITUDE, LATITUDE ] because OpenLayers uses the pair (Longitude before Latitude, i.e., toLonLat, fromLonLat).
  // const GEOGRAPHIC_CENTER_OF_UNITED_STATES = [44.967243, -103.771556];
  const DISTRICT_CENTER = [ 38.65254, -121.40317];
  const MAX_VISIBLE = 10000;
  const [coordinateRoundTo, setCoordinateRoundTo] = React.useState(3);
  // const [view, setView] = React.useState({ center: fromLonLat(GEOGRAPHIC_CENTER_OF_UNITED_STATES), zoom: 3, extent: [-20037508.34, 20037508.34, 20037508.34, -20037508.34] });
  const [centerLatitude, setCenterLatitude] = React.useState(DISTRICT_CENTER[0]);
  const [centerLongitude, setCenterLongitude] = React.useState(DISTRICT_CENTER[1]);
  const [viewport, setViewport] = React.useState({
    latitude: DISTRICT_CENTER[0],
    longitude: DISTRICT_CENTER[1],
    zoom: 9
  });
  const [postGeoJSON, setPostGeoJSON] = React.useState({
    "type": "FeatureCollection",
    "metadata": {
      "title": "Main Posts",
    },
    "features": []
  });
  // Bottom sliding pane state.
  let showOnboard = false;
  if (Auth.loggedIn()) {
    showOnboard = false;
  }
    
  const [isLoadingOpen, setIsLoadingOpen] = React.useState(false);
  const [isOnboardOpen, setIsOnboardOpen] = React.useState(showOnboard);
  const [isPostPaneOpen, setIsPostPaneOpen] = React.useState(false);
  const [isRegisterPaneOpen, setIsRegisterPaneOpen] = React.useState(false);
  const [isLoginPaneOpen, setIsLoginPaneOpen] = React.useState(false);
  const [isProfilePaneOpen, setIsProfilePaneOpen] = React.useState(false);
  const [isSelectedPaneOpen, setIsSelectedPaneOpen] = React.useState(false);
  const [isSinglePostOpen, setIsSinglePostOpen] = React.useState(false);
  const [isVisiblePaneOpen, setIsVisiblePaneOpen] = React.useState(false);
  const [isWaysPaneOpen, setIsWaysPaneOpen] = React.useState(false);
  const [isDemoPaneOpen, setIsDemoPaneOpen] = React.useState(false);
  const [isEditMode, setIsEditMode] = React.useState(false);
  const [isDemoMode, setIsDemoMode] = React.useState(false);
  const [editUser, setEditUser] = React.useState();
  const [editPostId, setEditPostId] = React.useState();
  const [editPostBody, setEditPostBody] = React.useState();
  const [currentUser, setCurrentUser] = React.useState(initialUser);
  //For clustering posts.
  const [distance, setDistance] = React.useState(35);
  const [selected, setSelected] = React.useState("Click a cluster for details");

  // For managing the user's current position.
  const [currentLatitude, setCurrentLatitude] = React.useState();
  const [currentLongitude, setCurrentLongitude] = React.useState();
  const [accuracy, setAccuracy] = React.useState();
  const [addressQuery, setAddressQuery] = React.useState('');
  const [latLonQuery, setLatLonQuery] = React.useState('');

  // For managing user clicks and date.
  const [selectedMapPosts, setSelectedMapPosts] = React.useState([]);
  const [focusBox, setFocusBox] = React.useState(null);
  const [geoJSONFilterGeometry, setGeoJSONFilterGeometry] = React.useState(null);
  const [geoJSONCountryFilterId, setGeoJSONCountryFilterId] = React.useState('');
  const [geoJSONCountrySubregionId, setGeoJSONCountrySubregionId] = React.useState('');
  const [isDrawingBox, setIsDrawingBox] = React.useState(false);
  const [mapBounds, setMapBounds] = React.useState(null);
  const centerSyncTimeoutRef = React.useRef(null);
  const lastBoundsFetchKeyRef = React.useRef(null);
  const [hasLoadedInitialPosts, setHasLoadedInitialPosts] = React.useState(false);

  // Getting posts.
  const { data: meData } = useQuery(GET_ME, { skip: !Auth.loggedIn() });
  const { data: latestData, loading: latestLoading } = useSubscription(POST_CREATED);
  const { data: postDeletedData, loading: postDeletedLoading } = useSubscription(POST_DELETED);
  const { data: postUpdatedData, loading: postUpdatedLoading } = useSubscription(POST_UPDATED);
  const [fetchPostById, { data: postByIdData, loading: postByIdLoading, error: postByIdError }] = useLazyQuery(GET_ONE_POST);
  
  // const [posts, setPosts] = React.useState([]);

  const [posts, dispatch] = React.useReducer(postReducer, []);
  const [postLength, setPostLength] = React.useState(0); // Create a reference to hold the full list of posts
  const [timeRangeMs, setTimeRangeMs] = useState({ min: null, max: null });
  const prevTimeBoundsRef = React.useRef({ min: null, max: null });
  const timeBounds = React.useMemo(() => {
    if (!posts || posts.length === 0) return { min: null, max: null };
    let min = Infinity;
    let max = -Infinity;
    for (const post of posts) {
      const t = new Date(post.createdAt).getTime();
      if (!Number.isFinite(t)) continue;
      if (t < min) min = t;
      if (t > max) max = t;
    }
    if (!Number.isFinite(min) || !Number.isFinite(max)) return { min: null, max: null };
    return { min, max };
  }, [posts]);

  React.useEffect(() => {
    if (timeBounds.min == null || timeBounds.max == null) return;

    const prevBounds = prevTimeBoundsRef.current;
    const hasPrevBounds = Number.isFinite(prevBounds.min) && Number.isFinite(prevBounds.max);

    setTimeRangeMs((prev) => {
      if (!prev.min || !prev.max || prev.min > prev.max) {
        return { min: timeBounds.min, max: timeBounds.max };
      }

      const clampedMin = Math.max(timeBounds.min, prev.min);
      const wasAtLatest =
        hasPrevBounds &&
        Number.isFinite(prev.max) &&
        Math.abs(prev.max - prevBounds.max) <= 60 * 1000;

      let nextMax = Math.min(timeBounds.max, prev.max);
      if (wasAtLatest) {
        // Keep the slider "pinned" to newest data when user was already at the live edge.
        nextMax = timeBounds.max;
      }

      if (clampedMin > nextMax) {
        return { min: timeBounds.min, max: timeBounds.max };
      }

      if (clampedMin !== prev.min || nextMax !== prev.max) {
        return { min: clampedMin, max: nextMax };
      }
      return prev;
    });

    prevTimeBoundsRef.current = { min: timeBounds.min, max: timeBounds.max };
  }, [timeBounds.min, timeBounds.max]);

  // For filtering posts.
  const [incomingPost, setIncomingPost] = React.useState();
  const [search, setSearch] = useState('');
  const [searchText, setSearchText] = useState('Search');
  const [searchMade, setSearchMade] = useState(false); // Add this line
  const location = useLocation();
  const navigate = useNavigate();
  const parsedUrlFilters = React.useMemo(
    () => parseFilterQueryString(location.search),
    [location.search]
  );
  const hasUrlFocusBox =
    Array.isArray(parsedUrlFilters?.focusBox) &&
    parsedUrlFilters.focusBox.length === 4 &&
    parsedUrlFilters.focusBox.every((entry) => Number.isFinite(Number(entry)));
  const hasUrlCountryParams =
    Boolean(parsedUrlFilters?.countryId) || Boolean(parsedUrlFilters?.countrySubregion);
  const shouldSkipAllPosts = hasUrlFocusBox || hasUrlCountryParams;
  const urlGeoBounds = hasUrlFocusBox
    ? parsedUrlFilters?.focusBox
    : parsedUrlFilters?.geoFilterBounds;

  const { data: initialData, loading: initialLoading, error: initialError } = useQuery(
    GET_ALL_POSTS,
    { skip: shouldSkipAllPosts }
  ); // Getting posts.
  const [fetchPostsInBounds, { data: boundedData, loading: boundedLoading, error: boundedError }] =
    useLazyQuery(GET_POSTS_IN_BOUNDS);

  const visiblePosts = React.useMemo(() => {
    if (!posts || posts.length === 0) return [];

    const rangeMin = timeRangeMs.min ?? -Infinity;
    const rangeMax = timeRangeMs.max ?? Infinity;

    const withTimestamps = posts
      .map((post) => ({
        post,
        createdAt: new Date(post.createdAt).getTime(),
      }))
      .filter((item) => Number.isFinite(item.createdAt))
      .filter((item) => item.createdAt >= rangeMin && item.createdAt <= rangeMax)
      .sort((a, b) => b.createdAt - a.createdAt);

    if (withTimestamps.length < MAX_VISIBLE) {
      return withTimestamps.map((item) => item.post);
    }

    return withTimestamps.slice(0, MAX_VISIBLE).map((item) => item.post);
  }, [posts, timeRangeMs.min, timeRangeMs.max]);

  const matchesSearch = React.useCallback((post, searchTermLower) => {
    if (!searchTermLower) return true;
    const body = post?.body?.toLowerCase?.() || '';
    const civicInfo = post?.civicInfo?.toLowerCase?.() || '';
    const username = post?.user?.username?.toLowerCase?.() || '';
    const postId = post?._id?.toLowerCase?.() || '';
    const solutions = JSON.stringify(post?.solutions || []).toLowerCase();
    const issues = JSON.stringify(post?.issues || []).toLowerCase();

    return (
      body.includes(searchTermLower) ||
      civicInfo.includes(searchTermLower) ||
      username.includes(searchTermLower) ||
      postId.includes(searchTermLower) ||
      solutions.includes(searchTermLower) ||
      issues.includes(searchTermLower)
    );
  }, []);

  const searchFilteredPosts = React.useMemo(() => {
    const searchTermLower = String(search || '').trim().toLowerCase();
    if (!searchTermLower) return visiblePosts;
    return visiblePosts.filter((post) => matchesSearch(post, searchTermLower));
  }, [visiblePosts, search, matchesSearch]);

  const focusFilteredPosts = React.useMemo(() => {
    if (!focusBox || !Array.isArray(focusBox) || focusBox.length !== 4) return searchFilteredPosts;
    const [minLng, minLat, maxLng, maxLat] = focusBox;
    return searchFilteredPosts.filter((post) => {
      const lat = Number(post?.latitude);
      const lon = Number(post?.longitude);
      if (!Number.isFinite(lat) || !Number.isFinite(lon)) return false;
      return lon >= minLng && lon <= maxLng && lat >= minLat && lat <= maxLat;
    });
  }, [searchFilteredPosts, focusBox]);

  const geoJSONSpatialIndex = React.useMemo(() => {
    return buildGeoJSONSpatialIndex(geoJSONFilterGeometry);
  }, [geoJSONFilterGeometry]);

  const geoJSONFilteredPosts = React.useMemo(() => {
    if (!geoJSONSpatialIndex?.tree) return focusFilteredPosts;

    return focusFilteredPosts.filter((post) => {
      const lat = Number(post?.latitude);
      const lon = Number(post?.longitude);
      if (!Number.isFinite(lat) || !Number.isFinite(lon)) return false;
      return pointInGeoJSONSpatialIndex(geoJSONSpatialIndex, lon, lat);
    });
  }, [focusFilteredPosts, geoJSONSpatialIndex]);

  const geoFilterBounds = React.useMemo(() => {
    if (!Array.isArray(geoJSONSpatialIndex?.bounds) || geoJSONSpatialIndex.bounds.length !== 4) {
      return null;
    }
    return geoJSONSpatialIndex.bounds;
  }, [geoJSONSpatialIndex]);
  const viewportBounds = React.useMemo(() => {
    if (!Array.isArray(mapBounds) || mapBounds.length !== 4) return null;
    const values = mapBounds.map((entry) => Number(entry));
    if (!values.every(Number.isFinite)) return null;
    const [lon1, lat1, lon2, lat2] = values;
    return [
      Math.min(lon1, lon2),
      Math.min(lat1, lat2),
      Math.max(lon1, lon2),
      Math.max(lat1, lat2),
    ];
  }, [mapBounds]);
  const geoBoundsForUrl = React.useMemo(() => {
    if (Array.isArray(viewportBounds) && viewportBounds.length === 4) {
      return viewportBounds;
    }
    if (Array.isArray(geoFilterBounds) && geoFilterBounds.length === 4) {
      return geoFilterBounds;
    }
    return null;
  }, [geoFilterBounds, viewportBounds]);
  const geoBoundsSource = React.useMemo(() => {
    if (Array.isArray(viewportBounds) && viewportBounds.length === 4) {
      return 'viewport';
    }
    if (Array.isArray(geoFilterBounds) && geoFilterBounds.length === 4) {
      return 'filter';
    }
    return '';
  }, [geoFilterBounds, viewportBounds]);
  const hasUserBounds = React.useMemo(() => {
    const hasFocusBox =
      Array.isArray(focusBox) &&
      focusBox.length === 4 &&
      focusBox.every((entry) => Number.isFinite(Number(entry)));
    const hasGeoBounds =
      Array.isArray(geoFilterBounds) &&
      geoFilterBounds.length === 4 &&
      geoFilterBounds.every((entry) => Number.isFinite(Number(entry)));
    return hasFocusBox || hasGeoBounds;
  }, [focusBox, geoFilterBounds]);
  const boundsForFetch = React.useMemo(() => {
    if (
      hasUrlFocusBox &&
      Array.isArray(parsedUrlFilters?.focusBox) &&
      parsedUrlFilters.focusBox.length === 4
    ) {
      return parsedUrlFilters.focusBox;
    }
    if (hasUrlCountryParams) {
      if (Array.isArray(geoFilterBounds) && geoFilterBounds.length === 4) {
        return geoFilterBounds;
      }
      return null;
    }
    if (Array.isArray(urlGeoBounds) && urlGeoBounds.length === 4) {
      return urlGeoBounds;
    }
    return null;
  }, [
    hasUrlFocusBox,
    parsedUrlFilters?.focusBox,
    hasUrlCountryParams,
    geoFilterBounds,
    urlGeoBounds,
  ]);
  const hasFetchBounds = React.useMemo(() => {
    if (!Array.isArray(boundsForFetch) || boundsForFetch.length !== 4) return false;
    return boundsForFetch.every((entry) => Number.isFinite(Number(entry)));
  }, [boundsForFetch]);
  const isPostInActiveBounds = React.useCallback(
    (post) => {
      if (!shouldSkipAllPosts) return true;
      if (!hasFetchBounds) return false;
      const [minLon, minLat, maxLon, maxLat] = boundsForFetch.map(Number);
      const lon = Number(post?.longitude);
      const lat = Number(post?.latitude);
      if (![lon, lat].every(Number.isFinite)) return false;
      return lon >= minLon && lon <= maxLon && lat >= minLat && lat <= maxLat;
    },
    [shouldSkipAllPosts, hasFetchBounds, boundsForFetch]
  );

  const [gpsSnackbarOpen, setGpsSnackbarOpen] = useState(false);
  const [introSnackbarOpen, setIntroSnackbarOpen] = useState(!Auth.loggedIn());
  const [postSnackbarOpen, setPostSnackbarOpen] = useState(false);
  const [postSnackbarText, setPostSnackbarText] = useState("Post updating...");
  const [randomPrompt, setRandomPrompt] = useState(getRandomPrompt());
  const [demoModeText, setDemoModeText] = useState("Welcome to the demo! Click to begin.");
  const shareUrl = React.useMemo(() => {
    const queryString = buildFilterQueryString({
      existingSearch: location.search,
      keyword: search,
      countryId: geoJSONCountryFilterId,
      countrySubregion: geoJSONCountrySubregionId,
      viewport: hasUserBounds ? viewport : null,
      focusBox,
      geoFilterBounds: geoBoundsForUrl,
      geoBoundsSource,
      timeRangeMs,
    });
    const params = new URLSearchParams(queryString);
    params.set('forceURL', 'true');
    const nextQuery = params.toString();
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    return `${origin}${location.pathname}${nextQuery ? `?${nextQuery}` : ''}`;
  }, [
    location.pathname,
    location.search,
    search,
    geoJSONCountryFilterId,
    geoJSONCountrySubregionId,
    hasUserBounds,
    viewport,
    focusBox,
    geoBoundsForUrl,
    geoBoundsSource,
    timeRangeMs
  ]);
  const forceURLParameter = React.useMemo(() => {
    const params = new URLSearchParams(location.search);
    return String(params.get('forceURL') || '').toLowerCase() === 'true';
  }, [location.search]);
  const postIdParameter = React.useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get('postId');
  }, [location.search]);
  const reportIconColor = meData?.me?.iconColor || '#462b65';
  const theme = createTheme({
    palette: {
      primary: {
        main: '#D6E4DD',
        // light: will be calculated from palette.primary.main,
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      }
    },
  });
  const setFocusBoxClamped = React.useCallback((bounds) => {
    setFocusBox(bounds);
  }, []);

  const goToNearestPost = React.useCallback(() => {
    const features = Array.isArray(postGeoJSON?.features) ? postGeoJSON.features : [];
    if (!features.length) return false;

    const originLat = Number.isFinite(currentLatitude)
      ? currentLatitude
      : Number.isFinite(viewport?.latitude)
        ? viewport.latitude
        : centerLatitude;
    const originLon = Number.isFinite(currentLongitude)
      ? currentLongitude
      : Number.isFinite(viewport?.longitude)
        ? viewport.longitude
        : centerLongitude;

    if (![originLat, originLon].every(Number.isFinite)) return false;

    const toRadians = (deg) => (deg * Math.PI) / 180;
    const haversineKm = (lat1, lon1, lat2, lon2) => {
      const earthRadiusKm = 6371;
      const dLat = toRadians(lat2 - lat1);
      const dLon = toRadians(lon2 - lon1);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRadians(lat1)) *
          Math.cos(toRadians(lat2)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);
      return earthRadiusKm * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    };

    let nearestFeature = null;
    let minDistanceKm = Infinity;

    for (let i = 0; i < features.length; i += 1) {
      const feature = features[i];
      const coordinates = feature?.geometry?.coordinates;
      const lon = Number(coordinates?.[0]);
      const lat = Number(coordinates?.[1]);
      if (![lat, lon].every(Number.isFinite)) continue;

      const distanceKm = haversineKm(originLat, originLon, lat, lon);
      if (distanceKm < minDistanceKm) {
        minDistanceKm = distanceKm;
        nearestFeature = feature;
      }
    }

    if (!nearestFeature) return false;

    const nearestLon = Number(nearestFeature.geometry.coordinates[0]);
    const nearestLat = Number(nearestFeature.geometry.coordinates[1]);

    setSelectedMapPosts([nearestFeature]);
    setIsSelectedPaneOpen(true);
    setCenterLatitude(nearestLat);
    setCenterLongitude(nearestLon);
    setViewport((prev) => ({
      ...prev,
      latitude: nearestLat,
      longitude: nearestLon,
      zoom: Math.max(Number(prev?.zoom) || 0, 14),
    }));

    return true;
  }, [
    postGeoJSON,
    currentLatitude,
    currentLongitude,
    viewport,
    centerLatitude,
    centerLongitude,
    setSelectedMapPosts,
    setIsSelectedPaneOpen,
    setCenterLatitude,
    setCenterLongitude,
    setViewport,
  ]);

  const filterData = async (searchTerm) => {
    const nextSearch = String(searchTerm || '').trim().toLowerCase();
    setSearch(nextSearch);
    setSearchMade(nextSearch.length > 0);
  };

  React.useEffect(() => {
    if (!forceURLParameter) return;

    const parsed = parseFilterQueryString(location.search);
    const nextKeyword = String(parsed.keyword || '').trim().toLowerCase();
    setSearch(nextKeyword);
    setSearchMade(nextKeyword.length > 0);
    setSearchText('Search');

    if (parsed.viewport) {
      setViewport((prev) => ({
        ...prev,
        latitude: parsed.viewport.latitude,
        longitude: parsed.viewport.longitude,
        zoom: Number.isFinite(parsed.viewport.zoom) ? parsed.viewport.zoom : prev.zoom,
      }));
      setCenterLatitude(parsed.viewport.latitude);
      setCenterLongitude(parsed.viewport.longitude);
    }

    const boundsSource = String(parsed.geoBoundsSource || '').toLowerCase();
    if (Array.isArray(parsed.focusBox) && parsed.focusBox.length === 4) {
      setFocusBoxClamped(parsed.focusBox);
    } else if (
      boundsSource !== 'viewport' &&
      Array.isArray(parsed.geoFilterBounds) &&
      parsed.geoFilterBounds.length === 4
    ) {
      setFocusBoxClamped(parsed.geoFilterBounds);
    } else {
      setFocusBox(null);
    }

    setGeoJSONFilterGeometry(null);
    setGeoJSONCountryFilterId(parsed.countryId || '');
    setGeoJSONCountrySubregionId(parsed.countrySubregion || '');

    const minFromUrl = parsed.timeRangeMs?.min;
    const maxFromUrl = parsed.timeRangeMs?.max;
    if (Number.isFinite(minFromUrl) || Number.isFinite(maxFromUrl)) {
      setTimeRangeMs((prev) => {
        const nextMin = Number.isFinite(minFromUrl) ? minFromUrl : prev.min;
        const nextMax = Number.isFinite(maxFromUrl) ? maxFromUrl : prev.max;
        if (Number.isFinite(nextMin) && Number.isFinite(nextMax) && nextMin > nextMax) {
          return { min: nextMax, max: nextMin };
        }
        return { min: nextMin, max: nextMax };
      });
    }

    const params = new URLSearchParams(location.search);
    params.set('forceURL', 'false');
    navigate(
      {
        pathname: location.pathname,
        search: `?${params.toString()}`,
      },
      { replace: true }
    );
  }, [
    forceURLParameter,
    location.search,
    location.pathname,
    navigate,
    setFocusBoxClamped,
    setTimeRangeMs,
    setViewport,
    setCenterLatitude,
    setCenterLongitude,
    setGeoJSONFilterGeometry,
    setGeoJSONCountryFilterId,
    setGeoJSONCountrySubregionId,
  ]);

  React.useEffect(() => {
    if (hasUrlFocusBox) {
      setFocusBox(urlGeoBounds);
    } else if (hasUrlCountryParams) {
      setFocusBox(null);
    }

    if (!shouldSkipAllPosts) {
      lastBoundsFetchKeyRef.current = null;
      return;
    }

    if (!hasFetchBounds) {
      lastBoundsFetchKeyRef.current = null;
      return;
    }

    const bounds = boundsForFetch.map(Number);

    const boundsKey = bounds.map((entry) => entry.toFixed(6)).join(',');
    if (lastBoundsFetchKeyRef.current === boundsKey) return;
    lastBoundsFetchKeyRef.current = boundsKey;

    const [minLon, minLat, maxLon, maxLat] = bounds;
    fetchPostsInBounds({
      variables: { minLat, minLon, maxLat, maxLon },
      fetchPolicy: 'network-only',
    });

  }, [
    fetchPostsInBounds,
    hasUrlFocusBox,
    hasUrlCountryParams,
    shouldSkipAllPosts,
    hasFetchBounds,
    boundsForFetch,
    urlGeoBounds,
    setFocusBox,
  ]);

  React.useEffect(() => {
    if (forceURLParameter) return;

    const timeoutId = window.setTimeout(() => {
      const nextQuery = buildFilterQueryString({
        existingSearch: location.search,
        keyword: search,
        countryId: geoJSONCountryFilterId,
        countrySubregion: geoJSONCountrySubregionId,
        viewport: hasUserBounds ? viewport : null,
        focusBox,
        geoFilterBounds: geoBoundsForUrl,
        geoBoundsSource,
        timeRangeMs,
      });
      const currentQuery = location.search.startsWith('?')
        ? location.search.slice(1)
        : location.search;

      if (nextQuery === currentQuery) return;

      navigate(
        {
          pathname: location.pathname,
          search: nextQuery ? `?${nextQuery}` : '',
        },
        { replace: true }
      );
    }, 180);

    return () => window.clearTimeout(timeoutId);
  }, [
    forceURLParameter,
    search,
    geoJSONCountryFilterId,
    geoJSONCountrySubregionId,
    hasUserBounds,
    viewport,
    focusBox,
    geoBoundsForUrl,
    geoBoundsSource,
    timeRangeMs,
    location.pathname,
    location.search,
    navigate,
  ]);
  
  React.useEffect(() => {
    if (!Number.isFinite(viewport?.latitude) || !Number.isFinite(viewport?.longitude)) {
      return undefined;
    }

    if (centerSyncTimeoutRef.current) {
      window.clearTimeout(centerSyncTimeoutRef.current);
    }

    centerSyncTimeoutRef.current = window.setTimeout(() => {
      setCenterLatitude(viewport.latitude);
      setCenterLongitude(viewport.longitude);
      centerSyncTimeoutRef.current = null;
    }, 150);

    return () => {
      if (centerSyncTimeoutRef.current) {
        window.clearTimeout(centerSyncTimeoutRef.current);
        centerSyncTimeoutRef.current = null;
      }
    };
  }, [viewport?.latitude, viewport?.longitude, setCenterLatitude, setCenterLongitude]);

  React.useEffect(() => {
    if (postIdParameter) {
      fetchPostById({ variables: { id: postIdParameter } });
    }
  }, [postIdParameter, fetchPostById]);

  React.useEffect(() => {
    if (!postIdParameter || postByIdLoading) return;

    const post = postByIdData?.post;
    if (post) {
      const geoJSON = postToGeoJSON([post]);
      const features = geoJSON?.features || [];
      if (features.length > 0) {
        setSelectedMapPosts(features);
        setIsSelectedPaneOpen(true);
        setViewport({
          latitude: post.latitude,
          longitude: post.longitude,
          zoom: 17
        });
      }
    } else if (postByIdError) {
      console.log("Failed to load post from postId:", postIdParameter, postByIdError);
    }
  }, [postIdParameter, postByIdLoading, postByIdData, postByIdError]);

  
  React.useEffect(() => {
    if (initialData && !initialLoading) {
      dispatch({ type: 'ADD_INITIAL_POSTS', post: initialData.posts });
      setHasLoadedInitialPosts(true);
    }
  }, [initialLoading, initialData]);

  React.useEffect(() => {
    if (!shouldSkipAllPosts) return;
    if (boundedLoading) return;
    if (boundedData?.postsInBounds) {
      dispatch({ type: 'RESET_POSTS', posts: boundedData.postsInBounds });
    }
  }, [boundedLoading, boundedData, shouldSkipAllPosts]);

  const mapPointsLoading =
    (!hasLoadedInitialPosts && initialLoading) || boundedLoading;



  // Set the initial posts when data is loaded
  // React.useEffect(() => {
  //   if (!loading && data) {
  //     setPosts(data.posts);
  //   }
  // }, [loading, data]);

  // Add a post when a new one is created
  React.useEffect(() => {
    const getLatestData = async () => {
      try {
        if (!latestLoading && latestData) {
          const created = latestData?.postCreated;
          if (!created?._id) return;
          if (posts.some((post) => post?._id === created._id)) return;

          if (!isPostInActiveBounds(created)) {
            return;
          }
          if (incomingPost) {
            if (latestData?.postCreated.body === incomingPost) {
              console.log("Post arrived!");
            } else {
              console.log("Latest Data:", latestData?.postCreated.body);
              console.log("Incoming Post:", incomingPost);
            }
          }
          dispatch({ type: 'ADD_POST', post: latestData.postCreated });
          // setViewport({latitude: latestData.postCreated.latitude, longitude: latestData.postCreated.longitude, zoom: 20})
          setIncomingPost(null);
          setPostSnackbarText("Post created! Click to zoom.");
          // setPostSnackbarOpen(false);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getLatestData();
  }, [latestLoading, latestData, isPostInActiveBounds, incomingPost, posts]);

  // Remove a post when it's deleted
  React.useEffect(() => {
    const getDeletedData = async () => {
      try {
        if (!postDeletedLoading && postDeletedData) {
          // console.log("Deleting:", postDeletedData);
          // console.log("From:", posts);
          dispatch({ type: 'DELETE_POST', post: postDeletedData.postDeleted });
        }
      } catch (error) {
        // console.log(error);
      }
    };
    getDeletedData();
  }, [postDeletedLoading, postDeletedData]);

  // Update a post when it's updated
  React.useEffect(() => {
    const getUpdatedData = async () => {
      try {
        if (!postUpdatedLoading && postUpdatedData) {
          const updated = postUpdatedData?.postUpdated;
          if (!updated?._id) return;
          if (!isPostInActiveBounds(updated)) {
            return;
          }
          const existing = posts.find((post) => post?._id === updated._id);
          if (existing && isPostEquivalent(existing, updated)) return;
          dispatch({ type: 'UPDATE_POST', post: updated });
        }
      } catch (error) {
        // console.log(error);
      }
    };
    getUpdatedData();
  }, [postUpdatedLoading, postUpdatedData, isPostInActiveBounds, posts]);

  React.useEffect(() => {
    async function setPostData() {
      try {
        if (geoJSONFilteredPosts) {
          const postData = postToGeoJSON(geoJSONFilteredPosts);
          setPostGeoJSON(postData);
          setPostLength(geoJSONFilteredPosts.length);
        }
      } catch (error) {
        // console.log(error);
      }
    }
    setPostData();
  }, [geoJSONFilteredPosts]);
//   React.useEffect(() => {
//     // This function checks if the user is logged in and updates currentUser accordingly
//     const checkLoginStatusAndUpdateUser = () => {
//       if (Auth.loggedIn()) {
//         // If logged in, set the currentUser to Auth.user._id
//         setCurrentUser(Auth.user._id);
//       } else {
//         // If not logged in, reset currentUser to null or any other default value
//         setCurrentUser(null);
//       }
//     }
//     checkLoginStatusAndUpdateUser();
//   return () => {
//     // Auth.off('loginStatusChanged', checkLoginStatusAndUpdateUser);
//   };
// }, [/* dependencies here, if any */]);
  return (
    <>
    <div key='app' className="parentContainer"  style={{overflow: "hidden", overflowY: "auto"}} >
      <Header 
        key="header"
        theme={theme}
        filterData={filterData}
        setSearch={setSearch}
        searchText={searchText}
        setSearchText={setSearchText}
        search={search}
        searchMade={searchMade}
        setSearchMade={setSearchMade}
        timeBounds={timeBounds}
        timeRangeMs={timeRangeMs}
        setTimeRangeMs={setTimeRangeMs}
        postLength={postLength}
        viewport={viewport}
        setViewport={setViewport}
        centerLatitude={centerLatitude}
        centerLongitude={centerLongitude}
        currentLatitude={currentLatitude}
        currentLongitude={currentLongitude}
        setCenterLatitude={setCenterLatitude}
        setCenterLongitude={setCenterLongitude}
        setCurrentLatitude={setCurrentLatitude}
        setCurrentLongitude={setCurrentLongitude}
        coordinateRoundTo={coordinateRoundTo}
        isOnboardOpen={isOnboardOpen}
        setIsOnboardOpen={setIsOnboardOpen}
        isPostPaneOpen={isPostPaneOpen}
        setIsPostPaneOpen={setIsPostPaneOpen}
        isLoginPaneOpen={isLoginPaneOpen}
        isProfilePaneOpen={isProfilePaneOpen}
        setIsProfilePaneOpen={setIsProfilePaneOpen}
        setIsLoginPaneOpen={setIsLoginPaneOpen}
        isRegisterPaneOpen={isRegisterPaneOpen}
        setIsRegisterPaneOpen={setIsRegisterPaneOpen}
        isVisiblePaneOpen={isVisiblePaneOpen}
        setIsVisiblePaneOpen={setIsVisiblePaneOpen}
        gpsSnackbarOpen={gpsSnackbarOpen}
        setGpsSnackbarOpen={setGpsSnackbarOpen}
        addressQuery={addressQuery}
        setAddressQuery={setAddressQuery}
        latLonQuery={latLonQuery}
        setLatLonQuery={setLatLonQuery}
        focusBox={focusBox}
        setFocusBox={setFocusBoxClamped}
        setGeoJSONFilterGeometry={setGeoJSONFilterGeometry}
        geoJSONFilterGeometry={geoJSONFilterGeometry}
        geoJSONCountryFilterId={geoJSONCountryFilterId}
        setGeoJSONCountryFilterId={setGeoJSONCountryFilterId}
        geoJSONCountrySubregionId={geoJSONCountrySubregionId}
        setGeoJSONCountrySubregionId={setGeoJSONCountrySubregionId}
        isDrawingBox={isDrawingBox}
        setIsDrawingBox={setIsDrawingBox}
        mapBounds={mapBounds}
        goToNearestPost={goToNearestPost}
        shareUrl={shareUrl}
        pointsLoading={initialLoading}
      />
      <PostMap
        key="map"
        className="postMap"
        postLength={postLength}
        viewport={viewport}
        setViewport={setViewport}
        centerLatitude={centerLatitude}
        centerLongitude={centerLongitude}
        reportIconColor={reportIconColor}
        pointsLoading={mapPointsLoading}
        setCenterLatitude={setCenterLatitude}
        setCenterLongitude={setCenterLongitude}
        currentLatitude={currentLatitude}
        currentLongitude={currentLongitude}
        setCurrentLatitude={setCurrentLatitude}
        setCurrentLongitude={setCurrentLongitude}
        postGeoJSON={postGeoJSON}
        setSelectedMapPosts={setSelectedMapPosts}
        selectedMapPosts={selectedMapPosts}
        setIsSelectedPaneOpen={setIsSelectedPaneOpen}
        isSelectedPaneOpen={isSelectedPaneOpen}
        setIsPostPaneOpen={setIsPostPaneOpen}
        setIsRegisterPaneOpen={setIsRegisterPaneOpen}
        setIsEditMode={setIsEditMode}
        focusBox={focusBox}
        geoJSONFilterGeometry={geoJSONFilterGeometry}
        setFocusBox={setFocusBoxClamped}
        isDrawingBox={isDrawingBox}
        setIsDrawingBox={setIsDrawingBox}
        setMapBounds={setMapBounds}
      />
    </div>
    <Footer
      filterData={filterData}
      setSearch={setSearch}
      searchText={searchText}
      setSearchText={setSearchText}
      search={search}
      searchMade={searchMade}
      setSearchMade={setSearchMade}
      postLength={postLength}
      viewport={viewport}
      setViewport={setViewport}
      centerLatitude={centerLatitude}
      centerLongitude={centerLongitude}
      currentLatitude={currentLatitude}
      currentLongitude={currentLongitude}
      setCenterLatitude={setCenterLatitude}
      setCenterLongitude={setCenterLongitude}
      setCurrentLatitude={setCurrentLatitude}
      setCurrentLongitude={setCurrentLongitude}
      coordinateRoundTo={coordinateRoundTo}
      isOnboardOpen={isOnboardOpen}
      setIsOnboardOpen={setIsOnboardOpen}
      isPostPaneOpen={isPostPaneOpen}
      setIsPostPaneOpen={setIsPostPaneOpen}
      isLoginPaneOpen={isLoginPaneOpen}
      setIsProfilePaneOpen={setIsProfilePaneOpen}
      setIsLoginPaneOpen={setIsLoginPaneOpen}
      isRegisterPaneOpen={isRegisterPaneOpen}
      setIsRegisterPaneOpen={setIsRegisterPaneOpen}
      isVisiblePaneOpen={isVisiblePaneOpen}
      setIsVisiblePaneOpen={setIsVisiblePaneOpen}
      gpsSnackbarOpen={gpsSnackbarOpen}
      setGpsSnackbarOpen={setGpsSnackbarOpen}
    ></Footer>
    <>
    <Dialog
        className={"dialog"}
        style={{background: "rgba(0,0,0,0)"}}
        open={isOnboardOpen}
        fullWidth={true}
      >
        <Onboard
          style={{ zIndex: -10,  transition: "none !important"}}
          key="selected"
          update={true}
          filterData={filterData}
          setSearch={setSearch}
          searchText={searchText}
          setSearchText={setSearchText}
          search={search}
          searchMade={searchMade}
          setSearchMade={setSearchMade}
          centerLatitude={centerLatitude}
          centerLongitude={centerLongitude}
          setEditUser={setEditUser}
          setEditPostId={setEditPostId}
          setEditPostBody={setEditPostBody}
          isOnboardOpen={isOnboardOpen}
          setIsOnboardOpen={setIsOnboardOpen}
          isDemoPaneOpen={isDemoPaneOpen}
          setIsDemoPaneOpen={setIsDemoPaneOpen}
          isRegisterPaneOpen={isRegisterPaneOpen}
          setIsRegisterPaneOpen={setIsRegisterPaneOpen}
          selectedMapPosts={selectedMapPosts}
          setSelectedMapPosts={selectedMapPosts}
          setIsSelectedPaneOpen={setIsSelectedPaneOpen}
          isSelectedPaneOpen={isSelectedPaneOpen}
          setIsVisiblePaneOpen={setIsVisiblePaneOpen}
          setIsPostPaneOpen={setIsPostPaneOpen}
          setIsEditMode={setIsEditMode}
          isDemoMode={isDemoMode}
          setIsDemoMode={setIsDemoMode}
          introSnackbarOpen={introSnackbarOpen}
          setIntroSnackbarOpen={setIntroSnackbarOpen}
          currentUser={currentUser}
          setCurrentUser={setCurrentUser}
          setViewport={setViewport}
          viewport={viewport}
        ></Onboard>
         <div className={"mx-auto close-button"}>
          <IconButton
              className={"mx-auto"}
              color="black"
              onClick={()=> {
                setIsOnboardOpen(false);
                setIntroSnackbarOpen(true);
              }}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </div>
      </Dialog>
      <Demo
        isDemoMode={isDemoMode}
        setIsDemoMode={setIsDemoMode}
        isDemoPaneOpen={isDemoPaneOpen}
        setIsDemoPaneOpen={setIsDemoPaneOpen}
      >
      </Demo>
      {/* <Dialog
        className={"demo"}
        classes={"demo"}
        open={isDemoPaneOpen}
      >
        <Demo
          style={{ zIndex: -10,  transition: "none !important"}}
          key="selected"
          update={true}
          filterData={filterData}
          setSearch={setSearch}
          searchText={searchText}
          setSearchText={setSearchText}
          search={search}
          searchMade={searchMade}
          setSearchMade={setSearchMade}
          centerLatitude={centerLatitude}
          centerLongitude={centerLongitude}
          setEditUser={setEditUser}
          setEditPostId={setEditPostId}
          setEditPostBody={setEditPostBody}
          isOnboardOpen={isOnboardOpen}
          setIsOnboardOpen={setIsOnboardOpen}
          isRegisterPaneOpen={isRegisterPaneOpen}
          setIsRegisterPaneOpen={setIsRegisterPaneOpen}
          selectedMapPosts={selectedMapPosts}
          setSelectedMapPosts={selectedMapPosts}
          setIsSelectedPaneOpen={setIsSelectedPaneOpen}
          isSelectedPaneOpen={isSelectedPaneOpen}
          setIsVisiblePaneOpen={setIsVisiblePaneOpen}
          setIsPostPaneOpen={setIsPostPaneOpen}
          setIsEditMode={setIsEditMode}
          isDemoMode={isDemoMode}
          setIsDemoMode={setIsDemoMode}
          introSnackbarOpen={introSnackbarOpen}
          setIntroSnackbarOpen={setIntroSnackbarOpen}
          currentUser={currentUser}
          setCurrentUser={setCurrentUser}
          setViewport={setViewport}
          viewport={viewport}
        ></Demo>
         <div className={"mx-auto close-button"}>
          <IconButton
              className={"mx-auto"}
              color="black"
              onClick={()=> {
                setIsDemoPaneOpen(false);
                setIntroSnackbarOpen(true);
              }}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </div>
      </Dialog> */}
      <Dialog
        className={"dialog"}
        fullWidth={true}
        open={isSelectedPaneOpen}
      >
        <SelectedPosts
          style={{ zIndex: -10, transition: "none !important"}}
          key="selected"
          update={true}
          filterData={filterData}
          setSearch={setSearch}
          searchText={searchText}
          setSearchText={setSearchText}
          search={search}
          searchMade={searchMade}
          setSearchMade={setSearchMade}
          centerLatitude={centerLatitude}
          centerLongitude={centerLongitude}
          setEditUser={setEditUser}
          setEditPostId={setEditPostId}
          setEditPostBody={setEditPostBody}
          selectedMapPosts={selectedMapPosts}
          setSelectedMapPosts={setSelectedMapPosts}
          setPostGeoJSON={setPostGeoJSON}
          setIsSelectedPaneOpen={setIsSelectedPaneOpen}
          isSelectedPaneOpen={isSelectedPaneOpen}
          setIsLoginPaneOpen={setIsLoginPaneOpen}
          setIsRegisterPaneOpen={setIsRegisterPaneOpen}
          setIsVisiblePaneOpen={setIsVisiblePaneOpen}
          setIsPostPaneOpen={setIsPostPaneOpen}
          setIsEditMode={setIsEditMode}
          currentUser={currentUser}
          setCurrentUser={setCurrentUser}
          setViewport={setViewport}
          viewport={viewport}
        ></SelectedPosts>
         <div className={"mx-auto close-button"}>
          <IconButton
              className={"mx-auto"}
              color="black"
              onClick={()=> {
                setIsSelectedPaneOpen(false);
              }}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </div>
      </Dialog>
  {/* Register Dialog */}
  <Dialog className={"dialog"} fullWidth={true} open={isRegisterPaneOpen}>
    <div className={"flex justify-center items-center mx-auto close-button"}>
      <IconButton
          className={"mx-auto"}
          style={{margin: '0'}}
          edge="start"
          color="black"
          onClick={()=> { setIsRegisterPaneOpen(false); }}
          aria-label="close"
        >
        <CloseIcon />
      </IconButton>
    </div>
    <Register 
      setIsLoginPaneOpen={setIsLoginPaneOpen}
      setIsRegisterPaneOpen={setIsRegisterPaneOpen}
    />
  </Dialog>
  <Dialog
    className={"dialog"}
    fullWidth={true}
    maxWidth="sm"
    open={isProfilePaneOpen}
    onClose={() => { setIsProfilePaneOpen(false); }}
  >
    <div className={"flex justify-center items-center mx-auto close-button"}>
      <IconButton
          className={"mx-auto"}
          style={{margin: '0'}}
          edge="start"
          color="black"
          onClick={()=> { setIsProfilePaneOpen(false); }}
          aria-label="close"
        >
        <CloseIcon />
      </IconButton>
    </div>
    <Profile />
  </Dialog>

  {/* Post Dialog - Not Edit Mode */}
  {!isEditMode &&
    <Dialog className={"dialog"} fullWidth={true} open={isPostPaneOpen}>
      <div className={"flex justify-center items-center mx-auto close-button"}>
        <IconButton
            className={"mx-auto"}
            style={{margin: '0'}}
            edge="start"
            color="black"
            onClick={()=> { setIsPostPaneOpen(false); }}
            aria-label="close"
          >
          <CloseIcon />
        </IconButton>
      </div>
      <Post 
        key="post"
        {...{ currentUser, setCurrentUser, currentLatitude, currentLongitude, centerLatitude, centerLongitude, setIsPostPaneOpen, setPostGeoJSON, postGeoJSON, setPostSnackbarOpen, incomingPost, setIncomingPost }}
      />
    </Dialog>
  }

  {/* Post Dialog - Edit Mode */}
  {isEditMode &&
    <Dialog className={"dialog"} fullWidth={true} open={isPostPaneOpen}>
      <div className={"flex justify-center items-center mx-auto close-button"}>
        <IconButton
            className={"mx-auto"}
            style={{margin: '0'}}
            edge="start"
            color="black"
            onClick={()=> { setIsPostPaneOpen(false); }}
            aria-label="close"
          >
          <CloseIcon />
        </IconButton>
      </div>
      <Post
        key="post-edit"
        update={true}
        {...{ editUser, editPostId, editPostBody, currentUser, setCurrentUser, currentLatitude, currentLongitude, centerLatitude, centerLongitude, setIsPostPaneOpen, setPostGeoJSON, postGeoJSON, setPostSnackbarOpen }}
      />
    </Dialog>
  }

  {/* Login Dialog */}
  <Dialog className={"dialog"} fullWidth={true} open={isLoginPaneOpen}>
    <div className={"flex justify-center items-center mx-auto close-button"}>
      <IconButton
          className={"mx-auto"}
          style={{margin: '0'}}
          edge="start"
          color="black"
          onClick={()=> { setIsLoginPaneOpen(false); }}
          aria-label="close"
        >
        <CloseIcon />
      </IconButton>
    </div>
    <Login 
      key="login"
      {...{ currentUser, setCurrentUser, setIsLoginPaneOpen, setIsRegisterPaneOpen }}
    />
  </Dialog>

  {/* Single Post Dialog */}
  {/* <Dialog className={"dialog"}  open={isSinglePostOpen}>
    <div className={"flex justify-center items-center mx-auto close-button"}>
      <IconButton
          className={"mx-auto"}
          style={{margin: '0'}}
          edge="start"
          color="black" 
          onClick={()=> { setIsSinglePostOpen(false); }}
          aria-label="close"
        >
        <CloseIcon />
      </IconButton>
    </div>
    <SinglePost
      key="singlePost"
      update={true}
      {...{ centerLatitude, centerLongitude, setEditUser, setEditPostId, setEditPostBody, selectedMapPosts, setSelectedMapPosts, setIsSelectedPaneOpen, isSelectedPaneOpen, setIsPostPaneOpen, isSinglePostOpen, setIsSinglePostOpen, setIsEditMode, setIsVisiblePaneOpen, setViewport, currentUser, setCurrentUser, viewport }}
    />
  </Dialog> */}

  {/* Visibility Pane Dialog */}
  <Dialog className={"dialog"} fullWidth={true} open={isVisiblePaneOpen}>
    <div className={"flex justify-center items-center mx-auto close-button"}>
      <IconButton
          className={"mx-auto"}
          style={{margin: '0'}}
          edge="start"
          color="black"
          onClick={()=> { setIsVisiblePaneOpen(false); }}
          aria-label="close"
        >
        <CloseIcon />
      </IconButton>
    </div>
    <Visible
      key="history"
      update={true}
      postGeoJSON={postGeoJSON}
      setSelectedMapPosts={setSelectedMapPosts}
      selectedMapPosts={selectedMapPosts}
      setIsSelectedPaneOpen={setIsSelectedPaneOpen}
      filterData={filterData}
      setSearch={setSearch}
      searchText={searchText}
      setSearchText={setSearchText}
      search={search}
      searchMade={searchMade}
      setSearchMade={setSearchMade}
      centerLatitude={centerLatitude}
      centerLongitude={centerLongitude}
      setEditUser={setEditUser}
      setEditPostId={setEditPostId}
      setEditPostBody={setEditPostBody}
      isSelectedPaneOpen={isSelectedPaneOpen}
      setIsVisiblePaneOpen={setIsVisiblePaneOpen}
      setIsPostPaneOpen={setIsPostPaneOpen}
      setIsEditMode={setIsEditMode}
      currentUser={currentUser}
      setCurrentUser={setCurrentUser}
      setViewport={setViewport}
      viewport={viewport}
    />
  </Dialog>
  <Dialog className={"dialog"} fullWidth={true} open={isVisiblePaneOpen}>
    <div className={"flex justify-center items-center mx-auto close-button"}>
      <IconButton
          className={"mx-auto"}
          style={{margin: '0'}}
          edge="start"
          color="black"
          onClick={()=> { setIsVisiblePaneOpen(false); }}
          aria-label="close"
        >
        <CloseIcon />
      </IconButton>
    </div>
    <Visible
      key="history"
      update={true}
      postGeoJSON={postGeoJSON}
      setSelectedMapPosts={setSelectedMapPosts}
      selectedMapPosts={selectedMapPosts}
      setIsSelectedPaneOpen={setIsSelectedPaneOpen}
      filterData={filterData}
      setSearch={setSearch}
      searchText={searchText}
      setSearchText={setSearchText}
      search={search}
      searchMade={searchMade}
      setSearchMade={setSearchMade}
      centerLatitude={centerLatitude}
      centerLongitude={centerLongitude}
      setEditUser={setEditUser}
      setEditPostId={setEditPostId}
      setEditPostBody={setEditPostBody}
      isSelectedPaneOpen={isSelectedPaneOpen}
      setIsVisiblePaneOpen={setIsVisiblePaneOpen}
      setIsPostPaneOpen={setIsPostPaneOpen}
      setIsEditMode={setIsEditMode}
      currentUser={currentUser}
      setCurrentUser={setCurrentUser}
      setViewport={setViewport}
      viewport={viewport}
    />
  </Dialog>
  <Dialog className={"dialog"} fullWidth={true} open={isWaysPaneOpen}>
    <div className={"flex justify-center items-center mx-auto close-button"}>
      <IconButton
          className={"mx-auto"}
          style={{margin: '0'}}
          edge="start"
          color="black"
          onClick={()=> { setIsWaysPaneOpen(false); }}
          aria-label="close"
        >
        <CloseIcon />
      </IconButton>
    </div>
    <Visible
      key="history"
      update={true}
      postGeoJSON={postGeoJSON}
      setSelectedMapPosts={setSelectedMapPosts}
      selectedMapPosts={selectedMapPosts}
      setIsSelectedPaneOpen={setIsSelectedPaneOpen}
      filterData={filterData}
      setSearch={setSearch}
      searchText={searchText}
      setSearchText={setSearchText}
      search={search}
      searchMade={searchMade}
      setSearchMade={setSearchMade}
      centerLatitude={centerLatitude}
      centerLongitude={centerLongitude}
      setEditUser={setEditUser}
      setEditPostId={setEditPostId}
      setEditPostBody={setEditPostBody}
      isSelectedPaneOpen={isSelectedPaneOpen}
      setIsVisiblePaneOpen={setIsVisiblePaneOpen}
      setIsPostPaneOpen={setIsPostPaneOpen}
      setIsEditMode={setIsEditMode}
      currentUser={currentUser}
      setCurrentUser={setCurrentUser}
      setViewport={setViewport}
      viewport={viewport}
    />
  </Dialog>
</>
      <Snackbar
          onClose={() => setGpsSnackbarOpen(false)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          className="toast-90"
          open={gpsSnackbarOpen}
          action={
            <React.Fragment>
              <IconButton size="small" aria-label="close" color="inherit" onClick={() => setGpsSnackbarOpen(false)}>
                <CloseIcon fontSize="small" />
              </IconButton>

            </React.Fragment>
          }
          key='setGpsSnackbar'
          message="Your GPS location is hidden."
      >
      </Snackbar>
      <Snackbar
        onClose={() => setIntroSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        className="toast-90"
        open={introSnackbarOpen}
        id="introSnackbar"
        key="introSnackbar"
        message={
          <span>
            <span
              style={{
                cursor: 'pointer',
                textDecoration: 'underline',
                // fontWeight: 600,
              }}
              onClick={() => {
                setIntroSnackbarOpen(false);
                setIsRegisterPaneOpen(true);
              }}
            >
              Register
           
            in two clicks, including this one.
            </span>{' '}
          </span>
        }
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => setIntroSnackbarOpen(false)}
          >
            <CloseIcon fontSize="medium" />
          </IconButton>
        }
      />

      <Snackbar
          onClose={() => setPostSnackbarOpen(false)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          className="toast-90"
          onClick={() => {
            if (latestData?.postCreated) {
              setPostSnackbarText("Post created! Click to zoom.");
              setSelectedMapPosts([latestData.postCreated]);
              setViewport({latitude: latestData.postCreated.latitude, longitude: latestData.postCreated.longitude, zoom: 17})
            }
          }}
          open={postSnackbarOpen}
          action={
            <React.Fragment>
              <IconButton size="small" aria-label="close" color="inherit" onClick={() => setPostSnackbarOpen(false)}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </React.Fragment>
          }
          key='postSnackbar'
          message={postSnackbarText} 
        />
        <Snackbar
          onClose={() => setIsDemoMode(false)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          className="toast-90"
          onClick={() => {
            setIsDemoMode(false);
            setIsDemoPaneOpen(true);
          }}
          open={isDemoMode}
          action={
            <React.Fragment>
              <IconButton size="small" aria-label="close" color="inherit" onClick={() => setPostSnackbarOpen(false)}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </React.Fragment>
          }
          key='demoMode'
          message={demoModeText} 
        />
        <ToastContainer
          position="top-center"
          className="toast-90"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
    </>
  )
};

export default Main;
